/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var utils = {},
    months = [
        gettext('January'),
        gettext('February'),
        gettext('March'),
        gettext('April'),
        gettext('May'),
        gettext('June'),
        gettext('July'),
        gettext('August'),
        gettext('September'),
        gettext('October'),
        gettext('November'),
        gettext('December')
    ];

utils.getCurrentDate = function ( setDate ) {
    var date = new Date(),
        month, result;

    if ( setDate ) {
        date = new Date(setDate);
    }

    month = months[date.getMonth()];

    if ( core.environment.language === 'en' ) {
        result = month + ' ' + date.getDate();
    } else {
        result = date.getDate() + ' ' + month;
    }

    return result;
};

module.exports = utils;
